import { Text } from '../../../atoms/text/text';

const Information = () => (
  <div>
    <Text className="mb-4">This helps you:</Text>
    <ul className="list-disc pl-5">
      <Text tag="li">
        <span className="font-semibold">Save your answers</span> and finish at your own pace
      </Text>
      <Text tag="li">
        Keep your information <span className="font-semibold">safe and private</span>
      </Text>
      <Text tag="li">Share your completed questionnaire with your care team</Text>
    </ul>
  </div>
);

export { Information };
